<template>
  <div class="content" v-if="!loading && blocks">
    <div class="lineBox" style="padding-top:10px;border:0px;">
      <span class="h3" style="float:let;margin-top:5px;">Bloqueios/Horários</span>
    </div>
    <div class="line">
      <div class="col6">
        Título: <br/><textarea style="width:450px;height:165px;" type="text" class="inputWire" v-model="blocks.title"/>
        <br/><br/>
        Subtítulo: <br/><textarea style="width:450px;height:165px;" type="text" class="inputWire" v-model="blocks.subtitle"/>
      </div>
      <!-- <div class="col6">
        <div class="inputLabel">Hora Abertura:</div>
        <input type="number" class="inputWire" style="width:450px;" v-model.number="blocks.open_time"/>
        <br/><br/>
        <div class="inputLabel">Hora Fechamento:</div>
        <input type="number" class="inputWire" style="width:450px;" v-model.number="blocks.close_time"/>
        <br/><br/>
        <div class="inputLabel">Abertura:</div>
        Automática: <input type="radio" name="scan" :value="true" v-model="blocks.opened"/> Não: <input type="radio" :value="false" name="scan" v-model="blocks.opened"/>
        <br/><br/>
        Bloquear acesso solicitando endereço: <br/>
        Não <input name="block" type="radio" value="NO" v-model="$store.state.company.block_address_navigation" checked/><br/>
        Sim, exibe lista de lojas <input name="block" type="radio" value="YES_LIST" v-model="$store.state.company.block_address_navigation"/><br/>
        Sim, direto para HOME <input name="block" type="radio" value="YES_DIRECT" v-model="$store.state.company.block_address_navigation"/>
        <br/><br/>
      </div> -->
    </div>

    <div style="clear:both;"></div>

    <div>
        <div style="clear:both;"></div>
        <div class="line">
          <h3>Plano de fundo da tela "Bem-vindo"</h3>

          <p>Adicionar plano de fundo de tamanho <b>pequeno</b>:</p>

          <div class="col6">
            <OpaDragImage @uploadImage="(image) => saveImageNewBlock(image, 'small')"/>
          </div>
          <div class="col6">
            <img v-if="blocks.bg_small" :src="getImage(blocks.bg_small) " style="max.width:400px;">
          </div>

        </div>

        <div style="clear:both;"></div>

        <div class="line">
          <p>Adicionar plano de fundo de tamanho <b>grande</b>:</p>
          <div class="col6">
            <OpaDragImage @uploadImage="(image) => saveImageNewBlock(image, 'large')"/>
          </div>
          <div class="col6">
            <img v-if="blocks.bg_large" :src="getImage(blocks.bg_large) " style="max.width:400px;">
          </div>
        </div>

        <div style="clear:both;"></div>

        <div class="line">
          <h3>Banner da tela "Bem-Vindo"</h3>
          <p>Adicionar banner de tamanho <b>pequeno</b>:</p>
            <div class="col6">
              <OpaDragImage @uploadImage="(image) => saveImageNewBlock(image, 'banner_small')"/>
            </div>
            <div class="col6">
              <img v-if="blocks.banner_small" :src="getImage(blocks.banner_small) " style="max.width:400px;">
            </div>
        </div>

        <div style="clear:both;"></div>

        <div class="line">
          <p>Adicionar banner de tamanho <b>grande</b>:</p>
          <div class="col6">
            <OpaDragImage @uploadImage="(image) => saveImageNewBlock(image, 'banner_large')"/>
          </div>
          <div class="col6">
            <img v-if="blocks.banner_large" :src="getImage(blocks.banner_large) " style="max.width:400px;">
          </div>
        </div>

    </div>

    <div style="clear:both;"></div>
    <div class="line">
      <div class="col6">
        <button @click="saveBlocks()" style="width:150px;">Salvar</button>
      </div>
    </div>
  </div>
  <div v-else>{{loading}}{{blocks}}</div>
</template>

<script>

import OpaDragImage from '@/components/OpaDragImage.vue'
import { EventBus } from '@/utils/event-bus'
import { mapGetters } from 'vuex'
import Images from '@/connection/Images'
import BlocksConn from '@/connection/block'

export default {
  name: 'Blocks',
  data () {
    return {
      modalBanner: false,
      tempBanner: null,
      loading: true,
      blocks: null
    }
  },

  components: {OpaDragImage},

  created () {
    if (!this.$store.state.company.block_address_navigation) {
      this.$store.state.company.block_address_navigation = "NO"
    }
    if (this.loading) {
      EventBus.$emit('showLoading', true)
    }
    this.loadBlocks()
  },

  methods: {
    ...mapGetters([ 'getAdmin', 'getCompany' ]),

    getImage (image) {
      if (image) {
        return 'https://' + this.getCompany().Id + '/img/' + this.getCompany().companyId + '/block/'  + image
      }
      return null
    },

    async loadBlocks () {
      let result = await BlocksConn.getBlocks()
      console.log(result)
      if (result.error) {
        this.blocks = {
          title : null,
          subtitle: null,
          open_time: 0,
          close_time: 0,
          opened: true,
          bg_small: null,
          bg_large: null,
          banner_small: null,
          banner_large: null
        }
        EventBus.$emit('showAlert', 'error', result.msg)
      } else {
        if (!result.blocks){
          this.blocks = {
            title : null,
            subtitle: null,
            open_time: 0,
            close_time: 0,
            opened: true,
            bg_small: null,
            bg_large: null,
            banner_small: null,
            banner_large: null
          }
        } else {
          this.$store.state.company.block_address_navigation = result.block_address_navigation
          this.blocks = result.blocks
        }
      }
      console.log(this.blocks)
      this.loading = false
      EventBus.$emit('showLoading', false)

    },

    async saveBlocks () {
      EventBus.$emit('showLoading', true)
      let result = await BlocksConn.saveBlocks(this.blocks, this.$store.state.company.block_address_navigation)
      EventBus.$emit('showLoading', false)
      if (!result.error) {
        this.blocks = result.blocks
        EventBus.$emit('showAlert', 'success', 'Bloqueios  atualizados!')
      } else {
        EventBus.$emit('showAlert', 'error', result.msg)
      }
    },

    async saveImageNewBlock (file, size) {
      console.log(file, size)
      if (file) {
        EventBus.$emit('showLoading', true)
        let result = await Images.saveBlockImage(file)
        EventBus.$emit('showLoading', false)
        if (result.error) {
          EventBus.$emit('showAlert', 'error', result.msg)
        } else if (result.data) {
          if (size === 'small'){
            this.blocks.bg_small = result.data
          } if (size === 'large') {
            this.blocks.bg_large = result.data
          }if (size === 'banner_small') {
            this.blocks.banner_small = result.data
          }if (size === 'banner_large') {
            this.blocks.banner_large = result.data
          }
          this.saveBlocks()
          this.$forceUpdate()
        } else {
          EventBus.$emit('showAlert', 'error', result.msg)
        }
      }
    }
  }
}
</script>
